export default "__VITE_ASSET__3a4213b7__$_?component__"